import { Typography } from '@mui/material';
import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

import css from './Column.module.scss';

export interface ColumnProps {
  className?: string;
  contentClassName?: string;
  header?: ReactNode;
  style?: any;
  wrapContent?: boolean;
}

export const Column: FC<React.PropsWithChildren<ColumnProps>> = ({
  children,
  className,
  contentClassName,
  header,
  style,
  wrapContent = false,
}) => (
  <div
    className={classNames(css.column, className)}
    data-sumo-test='column'
    style={style}
  >
    <div className={css.headerContainer}>
      {!!header && <Typography variant='subtitle1'>{header}</Typography>}
    </div>

    {wrapContent ? (
      <div className={classNames(css.columnContent, contentClassName)}>
        {children || <Typography>None</Typography>}
      </div>
    ) : (
      children
    )}
  </div>
);
